import { useState } from "react";
import { toast } from "sonner";
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import { Input } from "../ui/input";

const API = process.env.REACT_APP_BACKEND_URL;

export const AndroidNotify = ({ testId }) => {
    const [open, setOpen] = useState(false);
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("idle");

    const close = (nextOpen) => {
        setOpen(nextOpen);
        if (!nextOpen) {
            setEmail("");
            setStatus("idle");
        }
    };

    const submit = async (event) => {
        event.preventDefault();
        setStatus("sending");
        try {
            const response = await fetch(`${API}/api/android-notify`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email: email.trim() }),
            });
            if (!response.ok) throw new Error("notify failed");
            setStatus("sent");
        } catch {
            setStatus("idle");
            toast.error("We could not save your email — please try again.");
        }
    };

    return (
        <Dialog open={open} onOpenChange={close}>
            <div
                data-testid={`${testId}-note`}
                className="mt-2 text-center text-xs font-medium text-[#5C5F58]"
            >
                Android coming soon (1–3 days) ·{" "}
                <DialogTrigger asChild>
                    <button
                        type="button"
                        data-testid={testId}
                        className="font-bold text-[#2C3618] underline decoration-[#899B6A] underline-offset-4 transition-colors hover:text-[#4A5D23]"
                    >
                        Notify me
                    </button>
                </DialogTrigger>
            </div>
            <DialogContent
                data-testid={`${testId}-dialog`}
                className="border-[#D5D8CB] bg-[#F9F8F4] text-[#1D201A] sm:rounded-3xl"
            >
                <DialogHeader>
                    <DialogTitle className="font-display text-3xl font-medium tracking-[-0.02em]">
                        Android is coming soon.
                    </DialogTitle>
                    <DialogDescription className="text-[#5C5F58]">
                        Leave your email and we’ll let you know when Lunar is ready for Android.
                    </DialogDescription>
                </DialogHeader>
                {status === "sent" ? (
                    <div data-testid={`${testId}-success`} className="rounded-2xl bg-[#EEF1E5] p-4 text-sm text-[#2C3618]">
                        You’re on the list. We’ll email you when Android is ready.
                    </div>
                ) : (
                    <form onSubmit={submit} className="space-y-4">
                        <label className="block text-sm font-medium" htmlFor={`${testId}-email`}>
                            Email address
                        </label>
                        <Input
                            id={`${testId}-email`}
                            data-testid={`${testId}-email`}
                            type="email"
                            required
                            value={email}
                            onChange={(event) => setEmail(event.target.value)}
                            placeholder="you@example.com"
                            className="h-12 rounded-full border-[#C2C0B8] bg-white px-4"
                        />
                        <button
                            type="submit"
                            data-testid={`${testId}-submit`}
                            disabled={status === "sending"}
                            className="h-12 w-full rounded-full bg-[#2C3618] text-sm font-bold text-[#F9F8F4] transition-colors hover:bg-[#4A5D23] disabled:opacity-60"
                        >
                            {status === "sending" ? "Saving…" : "Notify me"}
                        </button>
                    </form>
                )}
                {status === "sent" && (
                    <DialogClose asChild>
                        <button
                            type="button"
                            data-testid={`${testId}-done`}
                            className="h-11 rounded-full border border-[#C2C0B8] text-sm font-bold text-[#2C3618]"
                        >
                            Done
                        </button>
                    </DialogClose>
                )}
            </DialogContent>
        </Dialog>
    );
};
